<script>
export const pageName = 'inventory-motors';
export const pageRoute = '/inventory/motors';
export const title = 'Motor Inventory'
export const requireMembership = true;

import { getCurrentUserId } from '../../js/auth.js'
import { listenToCurrentUserView, listenToMotorsInventory } from '../../js/readModel.js';
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { commands } from '../../js/lib/functions.js';
import { showConfirm } from '../../js/utils/confirm.js';
import { showToast } from '../../js/utils/toast.js';
import { listInventoryHistoryYears } from '../../../functions/domain/inventory/motorUtils.js';

export default {
	data() {
		return { 
			inventory: null,
			maxStore: 5000,
			singleMotorLimit: true,
			storeCapacity: 0,
			motors: [],
			sortOrder: '',
			sortKey: '',
			years: [2025],
			ready: false
		}
	},

	methods: {
		async boot(opts) {

			await listenToCurrentUserView(user => {
				this.maxStore = user.licensing.storeLimit;
				this.singleMotorLimit = user.licensing.singleMotorLimit;
				if(this.inventory)
					this.storeCapacity = Math.ceil((this.inventory.totalPropWeight / this.maxStore) * 100)
			})

			await listenToMotorsInventory(getCurrentUserId(), 'stock', inventory => {
				this.inventory = inventory;
				this.motors = [...this.inventory.motors].filter(m => m.quantity > 0)
				this.storeCapacity = Math.ceil((inventory.totalPropWeight / this.maxStore) * 100)
				this.sort('designation', 'asc')
			});
			
			this.years = listInventoryHistoryYears()

			this.ready = true;
		},
		sort(sortKey, sortOrder)
		{
			if(sortKey != this.sortKey)
			{
				this.sortKey = sortKey
				this.sortOrder = sortOrder || 'asc'
			}
			else if(sortOrder)
				this.sortOrder = sortOrder
			else if(this.sortOrder == 'asc')
				this.sortOrder = 'desc'
			else
				this.sortOrder = 'asc'
			
			this.doSort();
		},
		doSort()
		{
			switch(this.sortKey)
			{
				case 'classification':
					this.motors.sort((a, b) => {
						let result = (this.sortOrder == 'asc' ? a : b).classification.localeCompare((this.sortOrder == 'asc' ? b : a).classification)
						if(result == 0)
							result = (this.sortOrder == 'asc' ? a : b).designation.localeCompare((this.sortOrder == 'asc' ? b : a).designation, 'en', { numeric: true })
						if(result == 0)
							result = (this.sortOrder == 'asc' ? a : b).delay - (this.sortOrder == 'asc' ? b : a).delay
						return result
					});
					break;
				case 'manufacturer':
					this.motors.sort((a, b) => (this.sortOrder == 'asc' ? a : b).manufacturer.localeCompare((this.sortOrder == 'asc' ? b : a).manufacturer));
					break;
				case 'designation':
					this.motors.sort((a, b) => {
						let result = (this.sortOrder == 'asc' ? a : b).designation.localeCompare((this.sortOrder == 'asc' ? b : a).designation, 'en', { numeric: true })
						if(result == 0)
							result = (this.sortOrder == 'asc' ? a : b).delay - (this.sortOrder == 'asc' ? b : a).delay
						return result
					});
					break;
				case 'diameter':
					this.motors.sort((a, b) => (this.sortOrder == 'asc' ? a : b).diameter - (this.sortOrder == 'asc' ? b : a).diameter);
					break;
				case 'propType':
					this.motors.sort((a, b) => ((this.sortOrder == 'asc' ? a : b).propType || '').localeCompare((this.sortOrder == 'asc' ? b : a).propType || ''));
					break;
				case 'notes':
					this.motors.sort((a, b) => ((this.sortOrder == 'asc' ? a : b).notes || '').localeCompare((this.sortOrder == 'asc' ? b : a).notes || ''));
					break;
				case 'quantity':
					this.motors.sort((a, b) => (this.sortOrder == 'asc' ? a : b).quantity - (this.sortOrder == 'asc' ? b : a).quantity);
					break;
			}
		},
		async deleteMotors(motor)
		{
			commands.warmUp();

			showConfirm({
				title: 'Confirm deletion',
				message: `Are you sure you want to delete these motors? ${motor.designation}`,
				buttons: [
					{
						text: 'Cancel',
						style: 'white'
					},
					{
						text: 'Delete motors',
						style: 'danger',
						action: async () => {

							showLoading();
							
							let result = await commands.inventory.motors.delete({ motorId: motor.motorId });
							
							hideLoading();

							if(!result.success)
								showToast({ message: 'Error deleting motors', style: 'bg-danger'})

							showToast({
								message: 'Motors deleted',
								style: 'bg-success'
							})
						}
					}
				]
			})
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 mt-5">
				<h1 class="display-4 text-center mb-3">Motor Inventory</h1>
				<p class="text-muted text-center mb-3">Keep track of whats in your inventory for stock keeping purposes.</p>
				<p class="text-muted text-center mb-5">Using inventory motors in your flight logs will automatically adjust the stock levels and keep a track of how much propellant you've burned.</p>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-12 col-md-10 mb-5">
				<div class="header">
					<div class="header-body">
						<div class="row align-items-end">
							<div class="col">
								<h6 class="header-pretitle">Motor inventory</h6>
								<h1 class="header-title">Current stock</h1>
							</div>
							<div class="col-auto">
								<ul class="nav nav-tabs header-tabs">
									<li class="nav-item">
										<a href="/inventory/motors" class="nav-link text-center active">Current stock</a>
									</li>
									<li v-for="year of years" class="nav-item">
										<a :href="`/inventory/motors/usage/${year}`" class="nav-link text-center">{{year}}</a>
									</li>
								</ul>

							</div>
						</div> 

					</div>
				</div>
				
				<div class="row my-5">
					<div class="col text-center">
						<div :class="`avatar avatar-xxl p-4 mb-3 ${storeCapacity >= 100 ? 'text-danger' : ''}`">
							<svg viewBox="0 0 250 250" :class="`circular-progress ${storeCapacity >= 100 ? 'red' : ''}`" :style="`--progress: ${storeCapacity > 97 && storeCapacity < 100 ? 97 : Math.min(storeCapacity, 100)};`">
								<circle class="bg"></circle>
								<circle class="fg"></circle>
							</svg>
							<h6 class="text-uppercase text-secondary my-3">{{ storeCapacity }}%</h6>
							<h2 class="mb-0">{{ inventory.totalPropWeight }}g</h2>
						</div>
						<div>Legal store usage <a href="/account/licensing"><span class="fe fe-edit"></span></a></div>
					</div>
					<div v-if="singleMotorLimit && motors.filter(m => m.propWeight > 1000).length > 0" class="col text-center">
						<div class="alert alert-danger">
							<span class="fe fe-alert-triangle"></span>
							You have at least one motor with more than 1kg NEQ propellant. This does not meet <a href="/account/licensing">your legal licensing limits</a>. You require an explosives acquire-and-keep license.
						</div>
					</div>
				</div>

				<div v-if="storeCapacity >= 100" class="alert alert-danger">
					<h4>Warning!</h4>
					<p class="mb-0">You are at or above the legal limit of rocket motor propellant you are allowed to store. </p>
				</div>

				<div class="row justify-content-center mb-4">
					<div class="col-12 col-md-6">
						<a href="/inventory/motors/add" class="btn btn-block btn-primary">Add motor(s) <span class="fe fe-plus-circle"></span></a>
					</div>
				</div>

				<!-- <form v-if="motors.length >= 2" action="">
					<div class="form-group row align-items-center">
						<div class="col-auto">
							<label>Sort:</label>
						</div>
						<div class="col">
							<select v-model="sort" class="form-control" @change="doSort">
								<option value="name">Name</option>
								<option value="quantity">Quantity</option>
							</select>
						</div>
					</div>
				</form> -->
				<div class="card">
					<table class="table card-table table-striped">
						<thead>
							<tr>
								<th class="sort d-none d-lg-tc" @click="sort('classification')"><span aria-title="Classification">Cl.</span></th>
								<th class="sort" @click="sort('manufacturer')"><span aria-title="Manufacturer">Mfr.</span></th>
								<th class="sort" @click="sort('designation')">Motor</th>
								<th class="sort d-none d-lg-tc" @click="sort('diameter')"><span aria-title="Diameter (mm)">D.</span></th>
								<th class="sort d-none d-lg-tc" @click="sort('propType')"><span aria-title="Classification">Propellant.</span></th>
								<th class="sort" @click="sort('notes')">Notes</th>
								<th class="sort" @click="sort('quantity')"><span aria-title="Quantity">Qty.</span></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="motor in motors" :class="`${motor.propWeight > 1000 && singleMotorLimit ? 'table-danger' : null}`">
								<td class="d-none d-lg-tc">{{ motor.classification }}</td>
								<td>{{ motor.manufacturer }}</td>
								<td>{{ motor.designation }}-{{ motor.delay }}</td>
								<td class="d-none d-lg-tc">{{ motor.diameter }}</td>
								<td class="d-none d-lg-tc">{{ motor.propType }}</td>
								<td>{{ motor.notes }}</td>
								<td class="shrink text-center">{{ motor.quantity }}</td>
								<td class="px-0 shrink">
									<div class="dropdown">
										<button class="btn p-0 dropdown-ellipses dropdown-toggle" aria-haspopup="true" aria-expanded="true">
											<i class="fe fe-more-vertical"></i>
										</button>
										<div class="dropdown-menu dropdown-menu-end">
											<a :href="`/inventory/motors/${motor.motorId}/edit`" class="dropdown-item text-primary">
												<span class="fe fe-edit"></span> Edit
											</a>
											<button @click.prevent="deleteMotors(motor)" class="dropdown-item dropdown-item-danger">
												<span class="fe fe-trash-2"></span> Delete
											</button>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					
					<div v-if="motors.length == 0" class="card-body">
						<p class="text-muted mb-0 text-center">You do not have any motors inventory.</p>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
